import React, { Component } from 'react';
import { FaLongArrowAltLeft } from 'react-icons/all';
import { Link } from 'react-router-dom';
import App from './../../App';
import { Rating } from '@material-ui/lab/Rating';
import { getDetails } from './../../services/baseServices';
import { withRouter } from 'react-router-dom';

class ArticleDetails extends Component {
    constructor() {
        super();
        this.state = {
            article: {},
            isLoading: true,
			metaInfo:{}
        }
      };

      componentWillMount() {
        this.getArticleDetails();
        
      }

      getArticleDetails = () =>{
        getDetails("articles", this.props.match.params.id)
        .then((res) => {
          console.log("response", res);
          if(res.success){
            this.setState({ article: res.data, metaInfo:res.data.meta_info}, ()=>{
              this.setState({isLoading: false})
            });
          }else{
            this.setState({isLoading: false})
          }
        })
        .catch((errMsg) => {
          this.setState({isLoading: false})
          console.log("Error Message: ", errMsg);
        });
      }

    render() {
		const metaInfo = this.state.metaInfo

        return (
            <App layout="">
        <div className="main-content">
          <div className="page-header">
            <h2 className="page-title">Article Details</h2>
            <div className="ml-auto">
              <Link to={`${process.env.PUBLIC_URL}/articles/list`}
                    className="btn btn-sm btn-link"><FaLongArrowAltLeft/> Back to List</Link>
            </div>
          </div>

          {
            this.state.isLoading ?
              <div className={`card-block`}>
                <div className="block-body">
                  Loading...
                </div>
              </div>
              :
              <div className="card-block">
						<div className="block-header">
							<h4 className="block-title">Article Details</h4>
						</div>
						{this.state.isLoading ? (
							<div className={`card-block`}>
								<div className="block-body">Loading...</div>
							</div>
						) : (
							<div className="block-body">
								<>
									<table className="info-table col-12">
										<tbody>
											<tr>
												<td style={{ width: "250px" }}>Article Id</td>
												<td style={{ width: "20px", textAlign: "center" }}>
													:
												</td>
												<td>{this.state.article.id}</td>
											</tr>
											<tr>
												<td style={{ width: "250px" }}>
													Slug
												</td>
												<td style={{ width: "20px", textAlign: "center" }}>
													:
												</td>
												<td>{this.state.article.slug}</td>
											</tr>
											<tr>
												<td style={{ width: "250px" }}>
													Title
												</td>
												<td style={{ width: "20px", textAlign: "center" }}>
													:
												</td>
												<td>{this.state.article.title}</td>
											</tr>
											<tr>
												<td style={{ width: "250px" }}>BN Title</td>
												<td style={{ width: "20px", textAlign: "center" }}>
													:
												</td>
												<td>{this.state.article.bn_title}</td>
											</tr>
											
											<tr>
												<td style={{ width: "250px" }}>Help Topic</td>
												<td style={{ width: "20px", textAlign: "center" }}>
													:
												</td>
												<td>{this.state.article.help_topic_name}</td>
											</tr>
											
											<tr>
												<td style={{ width: "250px" }}>Public Visibility</td>
												<td style={{ width: "20px", textAlign: "center" }}>
													:
												</td>
												<td>{this.state.article.public_visibility? "True": "False"}</td>
											</tr>
											<tr>
												<td style={{ width: "250px" }}>Body</td>
												<td style={{ width: "20px", textAlign: "center" }}>
													:
												</td>
												<td dangerouslySetInnerHTML={{__html: this.state.article.body}}></td>
											</tr>
											<tr>
												<td style={{ width: "250px" }}>BN Body</td>
												<td style={{ width: "20px", textAlign: "center" }}>
													:
												</td>
												<td dangerouslySetInnerHTML={{__html: this.state.article.bn_body}}></td>
											</tr>
											<tr>
												<td style={{ width: "250px" }}>Footer Visibility</td>
												<td style={{ width: "20px", textAlign: "center" }}>
													:
												</td>
												<td>{this.state.article?.footer_visibility? "True": "False"}</td>
											</tr>
											<tr>
												<td style={{ width: "250px" }}>Position</td>
												<td style={{ width: "20px", textAlign: "center" }}>
													:
												</td>
												<td>{this.state.article?.position}</td>
											</tr>
										</tbody>
									</table>
								</>
							</div>
						)}
					</div>
					
          }
          
        </div>

		<div className="card-block">
          <div className="block-header">
            <h4 className="block-title">Meta Info</h4>
          </div>
          <div className="block-body">
            <table className="info-table">
              <tbody>
                <tr>
                  <td style={{ width: "200px" }}>Meta Title</td>
                  <td style={{ width: "20px", textAlign: "center" }}>
                    :
                  </td>
                  <td>{metaInfo?.meta_title}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px" }}>Meta Title in Bangla</td>
                  <td style={{ width: "20px", textAlign: "center" }}>
                    :
                  </td>
                  <td>{metaInfo?.bn_meta_title}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px" }}>Meta Description</td>
                  <td style={{ width: "20px", textAlign: "center" }}>
                    :
                  </td>
                  <td>{metaInfo?.meta_description}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px" }}>Meta Description in Bangla</td>
                  <td style={{ width: "20px", textAlign: "center" }}>
                    :
                  </td>
                  <td>{metaInfo?.bn_meta_description}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px" }}>Meta Keywords</td>
                  <td style={{ width: "20px", textAlign: "center" }}>
                    :
                  </td>
                  <td>{
                      metaInfo?.meta_keyword?.map((item,index)=>(
                        <span key={index}>{item}, </span>
                      ))
                  }</td>
                </tr>
                <tr>
                  <td style={{ width: "200px" }}>Meta Keywords in Bangla</td>
                  <td style={{ width: "20px", textAlign: "center" }}>
                    :
                  </td>
                  <td>{
                     metaInfo?.bn_meta_keyword?.map((item,index)=>(
                      <span key={index}>{item}, </span>
                    ))
                    }</td>
                </tr>
              </tbody>
            </table>
            </div>
            </div>
      </App>
        );
    }
}

export default withRouter(ArticleDetails);